const TitleFilter = (element: HTMLElement) => {
  const isEllipsisActive = element.offsetWidth < element.scrollWidth;
  const isLongTitleOnly = element.classList.contains("longTitleOnly");
  if (isLongTitleOnly) {
    if (isEllipsisActive) return true;
    else {
      element.title = "";
      return false;
    }
  }
  return true;
};

export default TitleFilter;
